var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { EnterFullscreen, ExitFullscreen } from '@volkswagen-onehub/icons-core';
import { MediaContext } from '..';
import { CTA } from '../../call-to-action';
import { styled } from '../../theme-provider';
const StyledFullscreenButton = styled(CTA).withConfig({ displayName: "StyledFullscreenButton", componentId: "sc-1moslbs" }) `flex-shrink:0;`;
function requestFullscreen(element, parent) {
    if (parent.requestFullscreen) {
        parent.requestFullscreen();
        return;
    }
    // iOS / Safari
    if (element.webkitEnterFullscreen) {
        element.webkitEnterFullscreen();
    }
}
function exitFullscreen() {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    }
    if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    }
}
export const FullscreenButton = (_a) => {
    var { closeTitle, openTitle } = _a, rest = __rest(_a, ["closeTitle", "openTitle"]);
    const mediaElement = React.useContext(MediaContext);
    const [fullscreen, setFullscreen] = React.useState(Boolean(document.fullscreenElement || document.webkitFullscreenElement));
    const handleFullscreenChange = React.useCallback(() => {
        setFullscreen(Boolean(document.fullscreenElement || document.webkitFullscreenElement));
    }, []);
    React.useEffect(() => {
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
        };
    }, [handleFullscreenChange]);
    const handleClick = React.useCallback((event) => {
        if (!mediaElement || !mediaElement.parentElement) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        fullscreen
            ? exitFullscreen()
            : requestFullscreen(mediaElement, mediaElement.parentElement);
    }, [mediaElement, fullscreen]);
    return (React.createElement(StyledFullscreenButton, Object.assign({ tag: "button", emphasis: "tertiary", onClick: handleClick, title: fullscreen ? closeTitle : openTitle, icon: fullscreen ? (React.createElement(ExitFullscreen, { ariaHidden: true })) : (React.createElement(EnterFullscreen, { ariaHidden: true })) }, rest)));
};
FullscreenButton.displayName = 'FullscreenButton';
